import { Box, Grid, Stack, useElementBreakpoints } from "@compass/core";
import { BulkSelected, Select } from "components";
import { BulkSelectedItemErrors, Contributor } from "generated/openApi";
import ApiService from "services/apiService";

export const SelectedContributors = (props: {
  contributors: Map<number, Contributor>;
  setContributors: (value: Map<number, Contributor>) => void;
  errors: BulkSelectedItemErrors[];
  setErrors: (value: BulkSelectedItemErrors[]) => void;
}) => {
  const { breakpointsRef, smallFieldBreakpoints, mediumFieldBreakpoints } = useElementBreakpoints();

  const getItemLabel = (contributor: Contributor) => (
    <Stack>
      {contributor.lastName}, {contributor.firstName}
    </Stack>
  );

  return (
    <Box ref={breakpointsRef}>
      <BulkSelected
        label="Contributor"
        items={props.contributors || []}
        setItems={(value) => props.setContributors(value)}
        getItemLabel={getItemLabel}
        errors={props.errors}
        setErrors={props.setErrors}
        quickAdd={
          <Grid container spacing="sm">
            <Grid item xs={smallFieldBreakpoints}>
              <Select
                label={`Add Contributor`}
                value={undefined as unknown as Contributor}
                onChange={(e, value) => {
                  const newContributors = new Map(props.contributors);
                  newContributors.set(value.id, value);
                  props.setContributors(newContributors);
                }}
                fetchFunction={(searchString) => ApiService.search.contributors(searchString)}
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionDisabled={(option) => props.contributors.has(option.id)}
                renderOption={(props, option) => (
                  <Box component="li" {...props}>
                    {getItemLabel(option)}
                  </Box>
                )}
                getOptionLabel={() => ""}
              />
            </Grid>
          </Grid>
        }
      />
    </Box>
  );
};
